<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <span>{{  "确定要删除吗？" }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isCancel">取 消</el-button>
      <el-button type="primary" @click="isDelete()">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: { dialogVisible: Boolean },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("isCancel");
    },
    isCancel() {
      this.$emit("isCancel");
    },
    isDelete(id) {
      this.$emit("isDelete");
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .el-form {
    display: flex;
    justify-content: space-around;
  }
  .el-dialog__body {
    display: flex;
    justify-content: center;
  }
  .el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/DeleteDialog1.vue